const es = {
    views: {
        home: {},
    },
};

export default es;
